/**
 * PG(PortOne V2 / KG이니시스) 카드사 코드 → 한글 결제수단 표기 변환.
 *
 * 결제 완료/상세의 "결제 수단" 에 raw 코드(KOOKMIN_CARD 등)가 그대로 노출되던 것을
 * "카드결제 KB국민카드" 형태로 한글화한다. (PaymentInfoSection 공통 적용)
 *
 * - 카드사 코드 매칭 시 → "카드결제 {한글카드사}"
 * - 일반 카드(CARD/CREDIT_CARD) → "카드결제"
 * - 이미 한글(간편결제 '토스페이' 등)·미매칭 값은 그대로 반환 (회귀 없음)
 */
const CARD_COMPANY_KO = {
  KOOKMIN_CARD: 'KB국민카드',
  KB_CARD: 'KB국민카드',
  SHINHAN_CARD: '신한카드',
  SAMSUNG_CARD: '삼성카드',
  HYUNDAI_CARD: '현대카드',
  LOTTE_CARD: '롯데카드',
  HANA_CARD: '하나카드',
  BC_CARD: 'BC카드',
  NH_CARD: 'NH농협카드',
  NONGHYUP_CARD: 'NH농협카드',
  WOORI_CARD: '우리카드',
  CITI_CARD: '씨티카드',
  KAKAOBANK: '카카오뱅크',
  KAKAO_BANK: '카카오뱅크',
  KBANK: '케이뱅크',
  K_BANK: '케이뱅크',
  TOSSBANK: '토스뱅크',
  TOSS_BANK: '토스뱅크',
  SUHYUP_CARD: '수협카드',
  JEONBUK_CARD: '전북카드',
  GWANGJU_CARD: '광주카드',
  JEJU_CARD: '제주카드',
  KDB_CARD: '산은카드',
  SAEMAUL: '새마을금고',
  SHINHYUP: '신협',
  POST: '우체국',
  EPOST: '우체국',
};

export function formatCardName(raw) {
  if (raw == null || typeof raw !== 'string') return raw;
  const key = raw.trim().toUpperCase();
  if (!key) return raw;
  if (CARD_COMPANY_KO[key]) return `카드결제 ${CARD_COMPANY_KO[key]}`;
  if (key === 'CARD' || key === 'CREDIT_CARD' || key === '카드' || key === '카드결제') return '카드결제';
  return raw;
}
